<template lang="pug">
  nav.navbar.is-fixed-top
    .container
      .navbar-brand
        router-link.navbar-item(:to="{name: 'home'}")
          img(src='../assets/images/hdr_logo.png', alt='Logo')
          strong.logo-text.is-size-5 申請書PDF作成

      .navbar-item(style="margin-left: auto;")
        portal-target(name="navbar-item")
</template>

<script>
export default {
  name: 'AppHeader',
  data () {
    return {
    }
  },
  watch: {
    $route ($route) {
      this.title = $route.meta.title
      this.subtitle = $route.meta.subtitle
    }
  },
  created () {
  }
}
</script>

<style scoped>
.logo-text {
  margin-left: .5em;
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeader.vue